import type { ModuleDefinition } from '../../../../app/moduleRegistry';

/** CMS İçerik: Kampanyalar (Campaign, wire object `AirCampaign`) — Master-GSA-only, gated
 *  behind `HasCmsB2C`. No longer a standalone routed page: `CampaignListPage` now requires a
 *  `siteId` prop and is rendered directly as a tab inside `SiteDetailPage` (see
 *  ../../site/site/pages/SiteDetailPage.tsx), so this sub-module contributes no route/menu
 *  item of its own — kept only so the sibling `cms/content` aggregator's import shape stays
 *  uniform. Its child resource `CampaignDetail` has no list route at all and stays nested
 *  CRUD inside the list page's edit dialog (see ./components/CampaignDetailsSection.tsx). */
export const campaignModule: ModuleDefinition = {
  routes: [],
  menuItems: [],
};
